























































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getInfo, HikEventData, postHandle } from '@/api/hikEvent'
import ViewDialog from '@/components/dialog/viewDialog.vue'

import { namespace } from 'vuex-class'
const UserModule = namespace('user')
@Component({
  components: { ViewDialog }
})
export default class HikEventView extends Vue {
  public tabName: string = 'tabBase'
  public collapseName: string[] = ['base', 'pics']
  public openHandleBox: boolean = false

  public visible: boolean = false
  public $refs!: {
  }
  public showDialog: boolean = false
  public loading: boolean = false
  public readonly: boolean = false
  public lvlList: any[] = [
    { Key: 0, Val: '--请选择--' },
    // { Key: 0, Val: '未配置' },
    { Key: 1, Val: '低' },
    { Key: 2, Val: '中' },
    { Key: 3, Val: '高' }
  ]
  public handleStatusList: any[] = [
    { Key: 3, Val: '处理中' },
    { Key: 2, Val: '已处理' }
  ]
  public form: HikEventData = new HikEventData()
  public handleForm = {
    GroupId: 0,
    Comments: '',
    Status: 0,
    EventLvl: 0
  }
  public created() { }
  public mounted() {
    window.eventBus.$on('viewHikEvent_Readonly', (id: number) => {
      this.readonly = true
      this.showDialog = true
      this.fetchData(id)
    })
    window.eventBus.$on('viewHikEvent', (id: number) => {
      this.readonly = false
      this.showDialog = true
      this.fetchData(id)
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('viewHikEvent_Readonly')
    window.eventBus.$off('viewHikEvent')
  }
  public closeDialog() {
    this.showDialog = false
  }
  //所有数据汇总一起查询
  public fetchData(id: number) {
    this.loading = true
    getInfo(id).then((response: { data: any }) => {
      const data = response.data
      if (data) {
        this.form = data
        if (!this.readonly) {
          this.handleForm = {
            GroupId: data.Id,
            Comments: '',
            Status: 0,
            EventLvl: data.EventLvl
          }
        }
        this.loading = false
      }
    })
  }
  public submitHandle() {
    var f = this.handleForm
    if (f.EventLvl == 0) {
      this.$message({
        message: '请选择事件级别',
        type: 'warning'
      })
      return false
    }
    if (f.Status == 0) {
      this.$message({
        message: '请选择处理状态',
        type: 'warning'
      })
      return false
    }
    if (f.Comments == '') {
      this.$message({
        message: '请输入处理内容',
        type: 'warning'
      })
      return false
    }
    postHandle(f).then((response: { data: any }) => {
      const data = response.data
      if (data && !data.IsError) {
        this.$message({
          message: '处理成功',
          type: 'success'
        })
        this.openHandleBox = false
        this.fetchData(f.GroupId)
      } else {
        this.$message({
          dangerouslyUseHTMLString: true, message: `${data.Message}`, type: 'warning'
        })
      }
    }, (data: any) => {
      console.log(data)
    })
  }
}
